module.exports = __webpack_public_path__ + "img/portal.bbdcf41e.gif";